import React, { useEffect } from 'react';
import { Form, Formik, useFormikContext } from 'formik';
import cc from 'classcat';
import { observer } from 'mobx-react-lite';
import styles from './shipsSearch.module.sass';
import { Button } from '../../Button';
import { useShipsSearchStore } from '../../../providers/RootStoreProvider';
import { SearchShips } from './components/SearchShips';
import { SearchDeck } from './components/SearchDeck';
import { CruiseType } from '../../SearchCruises/SearchCruises';
import { SwitchShips } from '../SwitchShips';
import { SkeletonCover } from '../../Skeleton/SkeletonCover';

const AutoSubmitFrom = observer(() => {
  const store = useShipsSearchStore();

  const setFilters = filters => store.setFilters(filters);
  // const clearFilters = () => store.clearFilters();
  const { values, submitForm, setFieldValue } = useFormikContext();

  useEffect(() => {
    setFilters(values);
    submitForm();
  }, [values]);

  const { type } = values;

  useEffect(() => {
    setFieldValue('selectedShips', []);
    setFieldValue('selectedDeck', []);
  }, [type]);

  return null;
});

export const ShipsSearch = observer(({ className, liners, ...props }) => {
  const store = useShipsSearchStore();
  const { shipsList = [], filterDecks = [], isLoading } = store;
  const filter = (c, s) => {
    store.filterByDecksAndShips(c, s);
  };

  if (isLoading) {
    return (
      <SkeletonCover
        width={'100%'}
        height={172}
        backgroundColor="#FFF"
        className={styles.skeleton}
      />
    );
  }


  return (
    <div
      className={cc([styles.wrapper, { [className]: !!className }])}
      {...props}
    >
      <Formik
        initialValues={{
          selectedDeck: [],
          selectedShips: [],
          type: store.filters?.type ?? CruiseType.Rivers,
        }}
        onSubmit={async ({ selectedDeck, selectedShips }) => {
          filter(selectedDeck, selectedShips);
        }}
      >
        {({ values }) => (
          <Form>
            <AutoSubmitFrom />
            <div className={styles.titleWrap}>
              <h1 className={styles.title}>{liners ? 'Морские лайнеры' : 'Речные теплоходы'}</h1>
            </div>
            <div className={styles.top}>
              <SearchShips
                id="selectedShips"
                label={liners ? 'Лайнер' : 'Теплоход'}
                ships={shipsList.map(ship => ship.name)}
                value={values.selectedShips}
                searchLabel={liners ? 'Поиск Лайнера' : 'Поиск Теплоход'}
              />
              <SearchDeck
                id="selectedDeck"
                label="Палубность"
                deck={filterDecks
                  .map(deck => deck.lable)
                  .map(String)
                  .sort()}
                value={values.selectedDeck}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
});
